<template>
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="'更新日志'" :width="600"
    @close="closeDialog" :default-cancel="false" :append-to-body="true">
    <div class="log-content">

      <h2>v1.1.1</h2>
      <ul>
        <li>支持文件夹分享</li>
        <li>修复编辑器读取文件错误时，报错信息显示有误</li>
        <li>支持新建文件</li>
        <li>支持右键菜单</li>
      </ul>

      <h2>v1.1.0</h2>
      <ul>
        <li>支持腾讯云账号登录</li>
        <li>支持文件编辑</li>
        <li>支持文件夹分享</li>
        <li>支持拉起客户端批量下载</li>
      </ul>

      <h2>v1.0.0</h2>
      <ul>
        <li>支持密钥登录</li>
        <li>存储桶支持以下操作：
          <ol>
            <li>创建、删除、搜索存储桶</li>
            <li>查看存储桶详情</li>
            <li>查看存储桶列表</li>
          </ol>
        </li>
        <li>文件对象支持以下操作：
          <ol>
            <li>中国地域支持上传文件/文件夹及选择上传属性</li>
            <li>新建文件夹</li>
            <li>单文件下载</li>
            <li>复制、粘贴对象</li>
            <li>前缀/模糊搜索</li>
            <li>文件列表按时间/大小排序</li>
            <li>支持分享、删除、重命名、查看对象详情</li>
          </ol>
        </li>
      </ul>

    </div>
  </qc-dialog>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';

export default {
  props: {
    show: {
      required: true,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  methods: {
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style lang="scss">
.log-content {
  max-height: 600px;
  padding-bottom: 25px;
  overflow-y: auto;
  h2 {
    margin-bottom: 16px;
    font-weight: 600;
    line-height: 1.25;
    border-bottom: 1px solid #eaecef;
  }

  ul {
    list-style: disc;
  }
  ol {
    list-style: decimal;
  }
  ul,
  ol {
    padding-left: 20px;
    margin-bottom: 16px;
    line-height: 24px;
    li {
      list-style: unset;
    }
  }
}
</style>
